import React from 'react';

export const HelpScreen = () => {
  return (
    <div>
      <h1> Help </h1>
    </div>
  )
};
